<template>
  <div class="page-features">
    <div id="featureSlider" class="page-features__container">
      <div class="page-features__header">
        <SectionHeader :title="$t('promo.features.section_header')" />
        <h2 class="page-features__title">{{ $t("promo.features.title") }}</h2>
      </div>

      <Swiper ref="feature_slider" :options="swiperSettings" class="page-features__slider">
        <SwiperSlide v-for="(card, index) in getSlides" :key="index" class="page-features__slide">
          <PageFeaturesCard
            type="info" :title="card.title" :text="card.text" :image="card.image" :video="card.video"
            :description="card.text"
          />
        </SwiperSlide>
      </Swiper>
      <div class="page-features__arrows">
        <Controller type="prev" class="controller controller--prev" />
        <Controller type="next" class="controller controller--next" />
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from "@static_promo_pages/common/components/redesign/section-header/vue/SectionHeader.vue";
import Controller from "@static_promo_pages/common/components/redesign/controllers/vue/Controller.vue";
import PageFeaturesCard from "./PageFeaturesCard.vue";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "PageFeaturesSlider",
  components: {
    SectionHeader,
    Controller,
    Swiper,
    SwiperSlide,
    PageFeaturesCard,
  },

  computed: {

    getSlides() {
      const texts = this.$t("promo.features.slides");

      return texts.map((item, index) => Object.assign({}, item, {
        image: require(`../images/slide-${index}.webp`),
        video: require(`../videos/slide-${index}.mp4`),
      }))
    },
    swiperSettings() {
      return {
        slidesPerView: "auto",
        centeredSlides: true,
        centeredSlidesBounds: true,
        allowTouchMove: true,
        loop: false,
        spaceBetween: 24,
        breakpoints: {
          1280: {
            spaceBetween: 32,
          },
        },
        navigation: {
          nextEl: ".controller--next",
          prevEl: ".controller--prev",
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/page-features-slider.scss";
</style>
